import { BitfRestPathBuilder } from '@bitf/core/parsers/rest-parser/bitf-rest-path.builder';

export class BitfMockDbPathBuilder extends BitfRestPathBuilder {}
